import { reactive } from "@vue/composition-api";
import axios from "axios";

let configs;
let cancelPricing = Function;
let cancelPriceListAccess = Function;

export default function useProductInfo () {

    if(configs == undefined){
        configs = reactive({});
    }
    
    const initProductConfig = (productId,price1,price2,preConfig,options) => {
        if(!configs[productId]){
            configs[productId] = reactive({
                config: [],
                price1: price1,
                price2: price2,
                required: [],
                missingInput: [],
                cartError: false
            });
        }
        if(preConfig !== undefined){
            preConfig.split('-').forEach(function(item){
                var selectedOption = options.find(function(option){
                    return option.config_id.replace('-','') == item || option.config_id.replace('-','') == item.replace(/[\d]{1,}/,'');
                });
                if(selectedOption){
                    if(selectedOption.user_input){
                        selectedOption.inputValue = item.substring(item.search(/[\d]{1,}/,item.length));
                    }
                    selectOption(selectedOption);
                }
            });
        }
    }

    //Adds an option to the current configuration
    const selectOption = function(option){
        var productId = option.product_id;
        //Don't add an option that needs user input unless there is user input
        if(option.user_input && option.inputValue !== undefined) {
            option.optionValue = option.inputValue;
        } else if (option.user_input){
            return;
        }
        //If an option already exists at that level/group location, just swap it out
        //If the option has user input though, don't swap unless we know it's in the group
        var existingIndex = configs[productId].config.findIndex(function(testOption) {
            return testOption.level == option.level && testOption.group_sort == option.group_sort;
        });
        var exactMatchIndex = configs[productId].config.findIndex(function(testOption) {
            return testOption.optid == option.optid;
        });
        existingIndex = (exactMatchIndex > -1) ? exactMatchIndex : existingIndex;

        if(existingIndex >= 0 && (!option.user_input || optionInConfig(option.optid,productId))){
            configs[productId].config.splice(existingIndex,1,option);
        } else {
            configs[productId].config.push(option);
        }

        //Make sure the config is sorted properly so we can build the name when needed
        configs[productId].config.sort(function(optiona, optionb){
            if(optiona.groupid > optionb.groupid) { return 1; }
            if(optiona.groupid < optionb.groupid) { return -1; }

            if(optiona.group_sort > optionb.group_sort) { return 1; }
            if(optiona.group_sort < optionb.group_sort) { return -1; }

            if(optiona.parent_option == ''){ return -1; }
            if(optiona.parent_option == optionb.parent_option) { return 1; }

            return 0;
        });

        //Remove any options that are no longer needed because their parent got changed
        for(var i = 0; i < configs[productId].config.length; i++){
            let option = configs[productId].config[i];
            if(option.parent_option != '' && !optionInConfig(option.parent_option,option.product_id)){
                configs[productId].config.splice(i,1);
                i--;
            }
        }
        updateMissingItems(productId);
    }

    const updateMissingItems = function(productId){
        configs[productId].missingInput = configs[productId].required.filter(function(optid){
            return configs[productId].config.findIndex(function(inConfig){
                return inConfig.optid == optid;
            }) == -1;
        });
    }

    const updatePrice = function(payload){
        configs[payload.prodConfig].price1 = payload.price1;
        configs[payload.prodConfig].price2 = payload.price2;
    }

    const addRequiredInput = function(option){
        if(configs[option.product_id].required.indexOf(option.optid) == -1){
            configs[option.product_id].required.push(option.optid);
        }
    }

    const removeRequiredInput = function(option){
        if(configs[option.product_id].required.indexOf(option.optid) != -1){
            configs[option.product_id].required.splice(configs[option.product_id].required.indexOf(option.optid),1);
        }
    }

    const removeOption = function(option){
        if(optionInConfig(option.optid,option.product_id)){
            var index = configs[option.product_id].config.findIndex(function(item){
                return item.optid == option.optid;
            });
            configs[option.product_id].config.splice(index,1);
        }
    }

    //Checks if an option exists in the current configuration
	const optionInConfig = function(optid, productId){
        return configs[productId].config.findIndex(function(element){
            return element.optid == optid;
        }) >= 0;
    }

    //Gets part list array
    const partsArray = function (productId){
        var partList = [];
        configs[productId].config.forEach(function(option){
            var v = (option.user_input) ? option.optionValue : 1;
            partList.push(option.part_id +':'+ v);
        });
        return partList;
    }
    //Build an array of -config_id values
    const productConfigurationArray = function(productId){
        var configList = [];
        configs[productId].config.forEach(function(option){
            var v = (option.user_input) ? option.optionValue : '';
            configList.push(option.config_id + v);
        });
        return configList;
    }
    //Build an array of config string values
    const productConfigurationStringArray = function (productId){
        var prodconList = [];
        configs[productId].config.forEach(function(option){
            if(option.config_id) {
                var v = (option.user_input) ? option.optionValue : '';
                prodconList.push('-('+option.gcode+')'+option.config_id.toString().replace('-','') + v);
            }
        });
        return prodconList;
    }

    const updatePricing = function(payload){
        cancelPricing();

        var params = new URLSearchParams({
            model: payload.PROD_MODEL,
            part: payload.PROD_ITEMNO,
            plist: partsArray(payload.PROD_ITEMNO).join(','),
            prefix: payload.CONFIG_PREFIX,
            config: productConfigurationArray(payload.PROD_ITEMNO).join(),
            configured: payload.PROD_CONFIG,
            prodcon: productConfigurationStringArray(payload.PROD_ITEMNO).join()
        });

        axios.post('/actions/cart.cfc?method=getProdInfo',params,{
            cancelToken: new axios.CancelToken(function executor(c){
                cancelPricing = c;
            })
        }).then(function(response){
            updatePrice({prodConfig:payload.PROD_ITEMNO,price1:response.data.price1,price2:response.data.price2});
        }).catch(function(thrown){
            if(!axios.isCancel(thrown)){
                console.warn(thrown);
            }
        });
    }

    const checkPriceListAccess = function(){
        cancelPriceListAccess();

        return axios
            .get('/actions/misc.cfc?method=checkPriceListAccess', {
                cancelToken: new axios.CancelToken(function executor(c){
                    cancelPriceListAccess = c;
                })
            })
            .then(function(response){
                var data = response && response.data;
                if(!data || typeof data !== 'string'){
                    return [];
                }

                var normalized = data
                    .split(',')
                    .map(function(s){ return (s || '').toString().trim().toUpperCase(); })
                    .filter(function(s){ return s.length; });

                // De-dupe while preserving order
                var seen = {};
                return normalized.filter(function(code){
                    if(seen[code]){ return false; }
                    seen[code] = true;
                    return true;
                });
            })
            .catch(function(thrown){
                if(!axios.isCancel(thrown)){
                    console.warn(thrown);
                }
                return [];
            });
    }

    const addToCart = function(payload){
        updateMissingItems(payload.prod_itemno);

        if(!validConfig(payload.prod_itemno)){
            return new Promise(function(resolve){
                resolve({data: {status: 400}});
            });
        } else {
            var params = new URLSearchParams({
                id: payload.id,
                configuration: productConfigurationArray(payload.prod_itemno).join(''),
                plist: partsArray(payload.prod_itemno).join(','),
                prodcon: productConfigurationStringArray(payload.prod_itemno).join('')
            });

            return new Promise(function(resolve){
                axios.post('/actions/cart.cfc?method=addToCart',params).then(function(response){
                    //Global Window function outside of VUE
                    if(response.data.status == 200){
                        window.updateCartCount(response.data.count);
                    }
                    resolve(response);
                });
            });
        }
    }

    const updateCartConfig = function(cartItem){
        updateMissingItems(cartItem.part);

        if(!validConfig(cartItem.part)){
            return new Promise(function(resolve){
                resolve({data: {status: 400}});
            });
        } else {
            var params = new URLSearchParams({
                id: cartItem.id,
                configuration: productConfigurationArray(cartItem.part).join(''),
                plist: partsArray(cartItem.part).join(','),
                prodcon: productConfigurationStringArray(cartItem.part).join(''),
                oldConfig: cartItem.c_part
            });
            return new Promise(function(resolve){
                axios.post('/actions/cart.cfc?method=updateCartItem',params).then(function(response){
                    resolve(response);
                });
            });
        }
    }

    const validConfig = function(productId){
        if(configs[productId].missingInput.length){
            configs[productId].cartError = true;
            return false;
        }
        return true;
    }

    //Gets an option from the config based on its id
    const getOptionInConfig = function(optid, productId){
        return configs[productId].config.filter(function(option){
            return option.optid == optid;
        });
    }
    //Gets the name of the config based on it's options
    const getConfigName = function(productId){
        var _result = '';
        configs[productId].config.forEach(function(option){
            _result += option.config_id;
            if(option.user_input && option.optionValue !== undefined){
                _result += option.optionValue;
            }
        });
        return _result;
    }
    //Gets the index in the config array of a level/group
    const configIndex = function(level, group_sort,productId){
        return configs[productId].config.findIndex(function(option){
            return option.level == level && option.group_sort == group_sort;
        });
    }
    //Checks if a current group has an option selected within the current configuration
    const groupConfigured = function (groupid, productId){
        return configs[productId].config.findIndex(function(element){
            return element.groupid == groupid;
        }) >= 0;
    }
    const getPrice = function(type,productId){
        return configs[productId][type];
    }
    const isInMissingInput = function(option){
        return (configs[option.product_id].missingInput.indexOf(option.optid) > -1);
    }
    const cartInError = function(productId){
        return configs[productId].cartError;
    }
    const parentConfigId = function(option) {
        var _result = '';
        var parentOption = getOptionInConfig(option.parent_option,option.product_id);

        if(parentOption.length){
            _result = parentOption[0].config_id;
        }

        return _result;
    }

    return {
        initProductConfig,
        selectOption,
        optionInConfig,
        updatePrice,
        addRequiredInput,
        removeRequiredInput,
        removeOption,
        updatePricing,
        checkPriceListAccess,
        addToCart,
        getOptionInConfig,
        getConfigName,
        configIndex,
        groupConfigured,
        getPrice,
        isInMissingInput,
        cartInError,
        parentConfigId,
        updateCartConfig
    }
}
